<template>
  <div class="container-fluid">
    <table id="tables-tab" class="table table-sm table-hover tablesorter mb-1" ref="projectTablesTab">
      <thead class="cf">
      <tr class="tablesorter-headerRow">


        <th scope="col" class="header tablesorter-header"
            v-on:click="$emit('select-ordering-column', 'name')">
          <div class="tablesorter-header-inner"
               :class="{'tablesorter-headerAsc': sortDirection === 'asc', 'tablesorter-headerUnSorted': sort !== 'name'}"
               :aria-sort="sort !== 'name' ? 'none' : undefined">
            <span>Name</span>
          </div>
        </th>
        <th scope="col" class="header tablesorter-header col-2"
            v-on:click="$emit('select-ordering-column', 'path')">
          <div class="tablesorter-header-inner"
               :class="{'tablesorter-headerAsc': sortDirection === 'asc', 'tablesorter-headerUnSorted': sort !== 'path'}"
               :aria-sort="sort !== 'path' ? 'none' : undefined">
            <span>Path</span>
          </div>
        </th>
        <th scope="col" class="header tablesorter-header col-2"
            v-on:click="$emit('select-ordering-column', 'status')">
          <div class="tablesorter-header-inner"
               :class="{'tablesorter-headerAsc': sortDirection === 'asc', 'tablesorter-headerUnSorted': sort !== 'status'}"
               :aria-sort="sort !== 'status' ? 'none' : undefined">
            <span>Status</span>
          </div>
        </th>
        <th scope="col" class="header tablesorter-header col-2 d-none d-lg-table-cell"
            v-on:click="$emit('select-ordering-column', 'creationDate')">
          <div class="tablesorter-header-inner"
               :class="{'tablesorter-headerAsc': sortDirection === 'asc', 'tablesorter-headerUnSorted': sort !== 'creationDate'}"
               :aria-sort="sort !== 'creationDate' ? 'none' : undefined">
            <span>Creation date</span>
          </div>
        </th>
        <th scope="col" class="header d-none d-sm-table-cell col-1">
        </th>
        <!--
        <th scope="col" class="header tablesorter-header sorter-false">
          <div class="">
            <span>Preprocessing state</span>
          </div>
        </th>
        <th scope="col" class="header tablesorter-header sorter-false">
          <div class="">
            <span>Annotation state</span>
          </div>
        </th>
        -->
      </tr>
      </thead>
      <tbody>
      <tr v-for="projectTable in tables" :key="projectTable.id" v-bind:id="'projectTable-'+projectTable.id" class="tableLine">

        <td class="align-middle col text-truncate d-none d-xl-table-cell clickable" style="max-width: calc(30*1vw)"
            v-on:click="$emit('select-table',projectTable )"
            :title="projectTable.name">{{ projectTable.name }}
        </td>
        <td class="align-middle col text-truncate d-xl-none small clickable" style="max-width: calc(30*1vw)"
            v-on:click="$emit('select-table',projectTable )"
            :title="projectTable.name">{{ projectTable.name }}
        </td>

        <td class="align-middle col-2 text-truncate d-none d-xl-table-cell clickable" style="max-width: calc(20*1vw)"
            v-on:click="$emit('select-table',projectTable )"
            :title="projectTable.path">{{ projectTable.path }}
        </td>
        <td class="align-middle col-2 text-truncate d-xl-none small clickable" style="max-width: calc(20*1vw)"
            v-on:click="$emit('select-table',projectTable )"
            :title="projectTable.path">{{ projectTable.path }}
        </td>

        <td class="align-middle col-2 text-truncate d-none d-xl-table-cell clickable" style="min-width: 17rem;"
            v-on:click="$emit('select-table',projectTable )"
            :title="projectTable.status">
          <StatusComponent class="float-left pb-0 pt-0 mb-0" :status="projectTable.status" ></StatusComponent>
        </td>
        <td class="align-middle col-2 text-truncate d-xl-none small clickable" style="width:calc(10vw);"
            v-on:click="$emit('select-table',projectTable )"
            :title="projectTable.status">
          <StatusComponent class="float-left pb-0 pt-0 mb-0" :status="projectTable.status" :SmallStatusComponent="true"></StatusComponent>
        </td>

        <td class="align-middle col-2 text-truncate d-none d-xl-table-cell clickable"  style="max-width: calc(18*1vw);" 
          v-on:click="$emit('select-table',projectTable )"
          :title="projectTable.creationDate">
          {{ projectTable.creationDate }}
        </td>
        <td class="align-middle col-2 text-truncate d-none d-lg-table-cell d-xl-none small clickable"
            v-on:click="$emit('select-table',projectTable )"
            style="max-width: calc(18*1vw)" :title="projectTable.creationDate">{{ projectTable.creationDate }}
        </td>
        <!--
        <td class="align-middle d-none d-sm-table-cell">
         <span class="btn-secondary icon icon-trash" aria-hidden="true"
               style="max-width: calc(40*1vw)"
               v-on:click="$emit('delete-table',projectTable.id )"></span>
        </td>
        -->
        <td class="align-middle d-none d-sm-table-cell col-1">
          <div class="float-right d-flex flex-row mt-1 mb-1">
          <div class="position-relative" :id="'dropdownBoundaryContainer-'+projectTable.id" :style="{'display': 'block'}">

            <a :id="'tableAnalysisActionLauncher-'+projectTable.id" class="align-items-center position-relative my-auto mb-4 mt-3 ml-1 btn btn-sm btn-secondary rounded" :data-boundary="'dropdownBoundaryContainer-'+projectTable.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :style="{'height': '30px', 'width': '30px'}">
              <span class="icon icon-More-dots mx-auto pb-1 pl-1" :style="{'transform': 'rotate(90deg)', 'height': '32px'}" title="Start Actions"></span>
            </a>

            <ul class="dropdown-menu dropdown-menu-right mt-0 mb-1" role="menu" :aria-labelledby="'tableAnalysisActionLauncher-'+projectTable.id">
              <div class="px-1 py-1">
                <div :title="launchOrRestartPreprocessingForbidden(projectTable) ? launchOrRestartPreprocessingForbiddenCause(projectTable) : launchOrRestartPreprocessingButtonText(projectTable)">
                  <li href="#" class="dropdown-item btn btn-sm" v-on:click="onStartTablePreProcessing(projectTable)" :active="false" :class="{'disabled': launchOrRestartPreprocessingForbidden(projectTable) }">{{ launchOrRestartPreprocessingButtonText(projectTable) }}</li>
                </div>
                <div :title="launchOrRestartAnnotationForbidden(projectTable) ? launchOrRestartAnnotationForbiddenCause(projectTable) : launchOrRestartAnnotationButtonText(projectTable)">
                  <li href="#" class="dropdown-item btn btn-sm" v-on:click="onStartTableAnnotation(projectTable)" :active="false" :class="{'disabled': launchOrRestartAnnotationForbidden(projectTable) }">{{ launchOrRestartAnnotationButtonText(projectTable) }}</li>
                </div>
                <div class="dropdown-divider"></div>
                <li href="#" class="dropdown-item btn btn-sm" v-on:click="$emit('delete-table',projectTable.id )" :active="false">Delete Table</li>
              </div>
            </ul>

          </div>
          </div>
        </td>


        <!--
        <td class="align-middle">{{ projectTable.preprocessing_status }}</td>
        <td class="align-middle">{{ projectTable.annotation_status }}</td>
        -->
      </tr>
      </tbody>
    </table>
  </div>

</template>
<script>
import Flip from '../../utils/Flip';
import StatusComponent from './content/StatusComponent';

export default {
  name: "Tables",
  components: {
    StatusComponent
  },
  props: ["tables", "sort", "sortDirection"],
  data() {
    return {
      flip: new Flip()
    }
  },
  updated: function() {
    let newTables = Array.from(document.querySelectorAll('.tableLine'));
    this.flip.play(newTables);
    this.flip = new Flip();
  },
  watch: {
    tables(val, oldVal) {
      console.log(`[watch] [tables] update ${(val && oldVal) ? '' : 'with missing value'}`);
      let existingTables = Array.from(document.querySelectorAll('.tableLine'));
      this.flip.read(existingTables);
    }
  },
  methods: {
    isDetailButtonDisabled: function(table) {
      return ((table === undefined) || ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED'].includes(table.status))
    },
    launchOrRestartPreprocessingButtonText: function(table) {
      if ((table === undefined) || ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED'].includes(table.status)) {
        return 'Start PreProcessing';
      } else {
        return 'Restart PreProcessing';
      }
    },
    launchOrRestartAnnotationButtonText: function(table) {
      if ((table === undefined) || ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED', 'PRE PROCESSING IN PROGRESS', 'PRE PROCESSING DONE', 'ANNOTATION IN ERROR', 'ANNOTATION FAILED'].includes(table.status)) {
        return 'Start Annotation';
      } else {
        return 'Restart Annotation';
      }
    },
    launchOrRestartPreprocessingForbidden(table) {
      return !table.isTableFileStillExisting;
    },
    launchOrRestartPreprocessingForbiddenCause() {
      return 'Forbidden: uploaded file is missing';
    },
    launchOrRestartAnnotationForbidden(table) {
      return ['UPLOADED', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED', 'PRE PROCESSING IN PROGRESS'].includes(table.status) && !table.isTableFileStillExisting;
    },
    launchOrRestartAnnotationForbiddenCause() {
      return 'Forbidden: uploaded file is missing';
    },
    onStartTablePreProcessing: function(table) {
      console.log("[onStartTablePreProcessing] -~~-> launch-preprocessing");
      this.$emit('launch-preprocessing', table.id);
    },
    onStartTableAnnotation: function(table) {
      console.log("[onStartTableAnnotation] -~~-> launch-annotation");
      this.$emit('launch-annotation', table.id);
    }
  }
};
</script>
<style scoped>
.tablesorter-headerAsc span:after{
  transform: rotate(180deg);
}

.tablesorter-header-inner[aria-sort="none"]:not(:hover) span::after {
  background-image: none;
}

.blink {
  animation: blinker 2s linear infinite;
}

.clickable {
  cursor: pointer
}

@keyframes blinker {
  50% {
    opacity: 0.5;
  }
}
</style>